<template>
    <div class="news-tool" :style="newsWidth">
      <div class="news-item" v-for="(item, index) of newsResult" :key="index">
        <div class="news-source">来源：{{item.source}}</div>
        <a :href="item.newsPath"
           target="_blank"
           :title="item.newsTitle + (item.source ? (' 新闻来源：' + item.source) : '')">
          <img :src="item.newsImagePath" width="100%" />
          <div style="width: 100%;text-align: left;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.newsTitle}}</div>
          <br>
        </a>
      </div>
    </div>
</template>

<script>
export default {
  name: 'NewsTool',
  data () {
    return {
      newsWidth: {
        width: 'calc(50% - 680px)'
      },
      news: [],
      newsResult: [],
      refreshNewsInterval: 3
    }
  },
  methods: {
    initGetNews () {
      this.$http.get(this.$api.getNews.url, {
        pageNum: 1,
        pageSize: 10
      }).then(_ => {
        if (_ && _.code === 200) {
          this.news = _.data.list || []
          this.$http.post(this.$api.newsRefreshInterval.url).then(_ => {
            if (_.code === 200 && _.data) {
              this.refreshNewsInterval = _.data
              setInterval(() => this.getNews(), this.refreshNewsInterval * 1000)
            }
          })
          this.getNews()
        }
      })
    },
    // 从列表中随机选取三个
    getNews () {
      let newsTmp = JSON.parse(JSON.stringify(this.news))
      this.newsResult = []
      for (let i = newsTmp.length - 1; i >= 0; i--) {
        let idx = Math.floor((Math.random() * i))
        if (this.newsResult.length < 3) {
          this.newsResult = this.newsResult.concat(newsTmp.splice(idx, 1))
        }
      }
    }
  },
  created () {
    this.initGetNews()
    // this.getNews()
  }
}
</script>

<style scoped>
.news-tool {
  position: fixed;
  top: 195px;
  left: 20px;
  padding: 20px;
  background: #ffffff;
}
  .news-item {
    position: relative;
  }
  .news-source {
    padding: 10px;
    font-size: 18px;
    font-weight: bolder;
    position: absolute;
    left: 0;
    top: 0;
    color: rgba(255, 255, 255, .7) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsTool/NewsTool.vue